export const RouterConfig = {
  root: "/",
  clock: "clock",
  signIn: "signIn",
};
